import * as yup from 'yup';
import { useTranslation } from 'react-i18next';

export const useTransactionPaymentCardValidation = () => {
    const { t } = useTranslation();
    return yup.object({
        email: yup.string().email(t('InvalidEmail')).nullable(),
        phoneCode: yup.number().required(t('RequiredField')).typeError(t('InvalidPhoneCode')).nullable(),
        phone: yup.string().required(t('RequiredField')).min(10).max(15).typeError(t('InvalidPhone')).nullable(),
        billCountry: yup.number().required(t('RequiredField')).typeError(t('InvalidCountry')).nullable(),
        billCity: yup.string().required(t('RequiredField')).min(3).max(50).typeError(t('InvalidCity')).nullable(),
        billAddress: yup.string().required(t('RequiredField')).min(4).max(50).typeError(t('InvalidAddress')).nullable(),
        billZip: yup.number().required(t('RequiredField')).lessThan(100000).typeError(t('InvalidNumber')).nullable()
    });
};
